import { FC } from "react";

import DatePeriodSelector from "../DatePeriodSelector/DatePeriodSelector";
import BrandWithCompetitorsSelect from "../BrandWithCompetitorsSelect/BrandWithCompetitorsSelect";
import OverviewModelSelect from "../OverviewModelSelect/OverviewModelSelect";
import { getHoursDiff } from "../HeaderBrandsSelector/utils/getHoursDiff";
import Skeleton from "../Skeleton/Skeleton";
import { HourglassIcon } from "../icons";
import { OverviewHeaderProps } from "./types";
import { DateSelectionMode, OverviewPeriod } from "../DatePeriodSelector/types";
import { isSameDay, startOfDay } from "date-fns";

import styles from "./OverviewHeader.module.css";



const OverviewHeader: FC<OverviewHeaderProps> = ({
  lastUpdateTime,
  dateFilter,
  onDateFilterChange,
}) => {
  const hoursSinceLastUpdate = getHoursDiff(lastUpdateTime);

  const period =
    dateFilter.type === DateSelectionMode.Period
      ? dateFilter.period
      : isSameDay(new Date(dateFilter.dateTs), startOfDay(new Date()))
        ? OverviewPeriod.OneDay
        : OverviewPeriod.SevenDays;
  const selectedDate =
    dateFilter.type === DateSelectionMode.Period
      ? new Date(dateFilter.startTs)
      : new Date(dateFilter.dateTs);
  const dateSelectionMode =
    dateFilter.type === DateSelectionMode.Period ? DateSelectionMode.Period : DateSelectionMode.Date;

  const renderLastUpdate = () => {
    if (!lastUpdateTime || !hoursSinceLastUpdate) {
      return <Skeleton height={24} width={167} variant="text" />;
    }

    return (
      <p className={styles["overview-header__update"]}>
        <HourglassIcon />
        UPDATED {hoursSinceLastUpdate} H AGO
      </p>
    )
  }

  return (
    <header className={styles["overview-header"]}>
      <div className={styles["overview-header__controls"]}>
        <div className={styles["overview-header__select-group"]}>
          <BrandWithCompetitorsSelect />
          <DatePeriodSelector
            period={period}
            selectedDate={selectedDate}
            mode={dateSelectionMode}
            onChange={onDateFilterChange}
          />
          <OverviewModelSelect className={styles["overview-header__select-model"]} />
        </div>
      </div>
      <div className={styles["overview-header__info"]}>
        {renderLastUpdate()}
      </div>
    </header>
  );
};

export default OverviewHeader;
